


// Your web app's Firebase configuration
export const firebaseconfiggestionale = {
    apiKey: "AIzaSyC3mlzBZBS1g9ud1XuN7eNkQ-SXGUHDm2c",
    authDomain: "mlabs-gestionale.firebaseapp.com",
    projectId: "mlabs-gestionale",
    storageBucket: "mlabs-gestionale.firebasestorage.app",
    messagingSenderId: "824389775970",
    appId: "1:824389775970:web:09596acf7cc83cdaa3173b"
};